import { Box } from "@mui/material";

const ContactUs: React.FC = () => {
    return (
        <Box></Box>
    );
};

export default ContactUs;